import { render, staticRenderFns } from "./OrganisationsList.vue?vue&type=template&id=25d23a52&scoped=true"
import script from "./OrganisationsList.vue?vue&type=script&lang=js"
export * from "./OrganisationsList.vue?vue&type=script&lang=js"
import style0 from "./OrganisationsList.vue?vue&type=style&index=0&id=25d23a52&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d23a52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d23a52')) {
      api.createRecord('25d23a52', component.options)
    } else {
      api.reload('25d23a52', component.options)
    }
    module.hot.accept("./OrganisationsList.vue?vue&type=template&id=25d23a52&scoped=true", function () {
      api.rerender('25d23a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationsList.vue"
export default component.exports